import PropTypes from 'prop-types';

export function notificationType() {
  return (
    PropTypes.shape({
      id:               PropTypes.number.isRequired,
      message:          PropTypes.string.isRequired,
      orgName:          PropTypes.string,
      orgType:          PropTypes.string,
      status:           PropTypes.string,
      timeStamp:        PropTypes.string,
      link:             PropTypes.string,
      downloadUrl:      PropTypes.string,
      linkButtonLabel:  PropTypes.string,
      unread:           PropTypes.bool.isRequired
    })
  );
}
